import type { ComponentPropsWithoutRef } from 'react';
import useTranslation from 'next-translate/useTranslation';
import clsx from 'clsx';

import Icon from '@/components/base/Icon';

type ReplyBadgeProps = ComponentPropsWithoutRef<'span'> & {
    withText?: boolean;
    isExport?: boolean;
};
export const ReplyBadge = ({
    className,
    withText = true,
    isExport = false,
    ...restProps
}: ReplyBadgeProps) => {
    const { t } = useTranslation('commons');

    return (
        <span
            className={clsx(
                'inline-flex items-center space-x-1 rounded bg-icoYellow-100 px-2 py-1 text-icoYellow',
                className,
                { 'dark:bg-icoYellow/20': !isExport }
            )}
            aria-label="reply-badge"
            {...restProps}>
            <Icon icon="reply" />
            {withText ? <span aria-label="reply">{t('tweet_reply')}</span> : null}
        </span>
    );
};
